import React, { FC } from 'react';
import { Tooltip } from '@firesoon/antd';
import { Information } from '@firesoon/icons-react';
import classnames from 'classnames';
import { LabelProps } from '../interface';
import '../index.less';

const Label: FC<LabelProps> = ({
  text,
  tooltips,
  icon = <Information style={{ color: '#999' }} />,
  colon = true,
  strong = true,
  disabled = false,
  secondary = false,
  children,
}) => {
  const prefix = 'fs-text-label';
  return (
    <label
      className={classnames(prefix, {
        [`${prefix}-no-colon`]: !colon,
        [`${prefix}-strong`]: strong,
        [`${prefix}-disabled`]: disabled,
        [`${prefix}-secondary`]: secondary,
      })}
    >
      <span className={`${prefix}-text`}>{children || text}</span>
      {(() => {
        if (tooltips) {
          return (
            <Tooltip title={tooltips}>
              <span className={`${prefix}-icon`}>{icon} </span>
            </Tooltip>
          );
        }
      })()}
    </label>
  );
};

export default Label;
